import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKaggleComponent } from './simple-icons-kaggle.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKaggleComponent ],
    exports:      [ SimpleIconsKaggleComponent ],
    bootstrap:    []
})
export class SimpleIconsKaggleModule {}
